class Backend {
  constructor(url) {
    this.url = url;
  }

  offers(game, itemType, descriptor) {
      return fetch(this.url + "/offers", {
        method: "POST",
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          game: game.name,
          itemType: itemType.name,
          descriptor: descriptor
        })
      })
        .then(response => response.json())
  }

  games() {
  	return fetch(this.url + "/games", {mode: 'cors'})
      .then(response => response.json())
  }

  version() {
  	return fetch(this.url + "/version", {mode: 'cors'})
  	  .then(response => response.text())
  }

  getAvgSoldPriceOfDescriptorByInterval(globalItemTypeId) {
    return fetch(this.url + "/getAvgSoldPriceOfDescriptorByInterval", {
        method: "POST",
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          globalItemTypeId: globalItemTypeId
        })
      })
        .then(response => response.json())
  }

  getAvgOffersPerDescriptor() {
    return fetch(this.url + "/avgOffers", {
      method: "POST",
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
  }

  getAvgOffersPerDescriptorWow() {
    return fetch(this.url + "/avgWowRetailGold", {
      method: "POST",
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
  }

  getAvgOffersPerDescriptorWowTbc() {
    return fetch(this.url + "/avgWowTbcClassicGold", {
      method: "POST",
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
  }

  getAvgPerTop3(game, itemType) {
    return fetch(this.url + "/top3PerItemType", {
        method: "POST",
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          game: game,
          itemType: itemType
        })
      })
        .then(response => response.json())

  }


  fetchWowOrderSuggestions(csvUrl) {
      return fetch(this.url + "/fetchWowOrderSuggestions", {
        method: "POST",
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          csvUrl: csvUrl
        })
      })
        .then(response => response.json())
  }

  providers() {
    return fetch(this.url + "/providers", {mode: 'cors'})
      .then(response => response.json())
  }

  avgPerTopHistory(game, itemType, descriptor, provider, resolutionSeconds, from, to) {
    return fetch(this.url + "/avgPerTopHistory", {
        method: "POST",
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          game: game,
          itemType: itemType,
          descriptor: descriptor,
          provider: provider,
          resolutionSeconds: resolutionSeconds,
          from: from.toISOString(),
          to: to.toISOString()
        })
      })
        .then(response => response.json())
  }

  avgTop7WowRetailGold() {
    return fetch(this.url + "/avgTop7WowRetailGold", {
      method: "POST",
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
  }

}

export default Backend;